module.exports = __webpack_public_path__ + "img/bigTruck-red.d6faff0f.svg";